export default "__VITE_ASSET__D7__Sf0x__"